// Vendor Imports
import React from 'react';

// Project Imports
import { CalendarDateFilterEditor, type CalendarDateFilterEditorProps } from './CalendarDateFilterEditor';
import { CheckboxFilterEditor, type CheckboxFilterEditorProps } from './CheckboxFilterEditor';
import ComputedColumnFilterEditor, {
  type ComputedColumnFilterEditorProps,
} from './ComputedColumnFilterEditor';
import { NumberFilterEditor, type NumberFilterEditorProps } from './NumberFilterEditor';
import { RadiusFilterEditor, type RadiusFilterEditorProps } from './RadiusFilterEditor';
import { TextFilterEditor, type TextFilterEditorProps } from './TextFilterEditor';
import { type FilterEditorProps } from '../types';
import { FilterDataType } from '../SoqlFilter';

const FilterEditor = (props: FilterEditorProps) => {
  const { appliedFilter } = props;
  if (!appliedFilter.dataTypeName) {
    return null;
  }

  switch (appliedFilter.dataTypeName) {
    case FilterDataType.CHECKBOX:
      return <CheckboxFilterEditor {...(props as CheckboxFilterEditorProps)} />;
    case FilterDataType.COMPUTED:
      return <ComputedColumnFilterEditor {...(props as ComputedColumnFilterEditorProps)} />;
    case FilterDataType.DATE:
      return <CalendarDateFilterEditor {...(props as CalendarDateFilterEditorProps)} />;
    case FilterDataType.NUMBER:
      return <NumberFilterEditor {...(props as NumberFilterEditorProps)} />;
    case FilterDataType.RADIUS:
      return <RadiusFilterEditor {...(props as RadiusFilterEditorProps)} />;
    case FilterDataType.TEXT:
      return <TextFilterEditor {...(props as TextFilterEditorProps)} />;
    default:
      return null;
  }
};

export default FilterEditor;
